// extracted by mini-css-extract-plugin
module.exports = {"pay":"pay-bounty_pay__4Ay1N"};